import LegacyStatsField from './legacy-stats-field'
import TagSelector from './tag-selector'
import slugify from '../../slugify'

export default [
  { name: 'Name', prop: 'name', type: 'text' },
  { name: 'URL', prop: 'slug', type: 'text', filter: slugify },
  { name: 'Email Domains', prop: 'email_domains', type: 'chipinput' },
  { name: 'Address line 1', prop: 'address_line_1', type: 'text' },
  { name: 'Address line 2', prop: 'address_line_2', type: 'text' },
  { name: 'City', prop: 'city', type: 'text' },
  { name: 'Postal Code', prop: 'postal_code', type: 'text' },
  {
    name: 'CountryState',
    type: 'country-state',
    stateProp: 'state',
    countryProp: 'country'
  },
  { name: 'Spots In FSP', prop: 'spots_in_fsp', type: 'number' },
  { name: 'Renewal Confirmed Status', prop: 'renewal_confirmed_status', type: 'checkbox' },
  { name: 'Announcement Date', prop: 'announcement_date', type: 'date' },
  { name: 'Total Faculty At Institution', prop: 'total_faculty_at_institution', type: 'number' },
  { name: 'Promotion Interests', prop: 'promotion_interests', type: 'text' },
  { name: 'Desired Six Month Outcome', prop: 'desired_six_month_outcome', type: 'text' },
  { name: 'Desired One Year Outcome', prop: 'desired_one_year_outcome', type: 'text' },
  { name: 'Final Thoughts', prop: 'final_thoughts', type: 'text' },
  { name: 'Tags', prop: 'tags', type: 'component', component: TagSelector },
  { name: 'Personalized Message', prop: 'personalized_message', type: 'textarea' },
  { name: 'Hero Image', prop: 'hero_image', type: 'image', url: 'hero_image_url' },
  { name: 'Logo Image', prop: 'logo_image', type: 'image', url: 'logo_image_url' },
  {
    name: 'Legacy Stats',
    prop: 'legacy_stats',
    type: 'component',
    component: LegacyStatsField
  }
]
